import { render, staticRenderFns } from "./anunt-5.vue?vue&type=template&id=394ecdc2&scoped=true"
import script from "./anunt-5.vue?vue&type=script&lang=js"
export * from "./anunt-5.vue?vue&type=script&lang=js"
import style0 from "./anunt-5.vue?vue&type=style&index=0&id=394ecdc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ecdc2",
  null
  
)

export default component.exports